import React from "react";
import { Navbar2 } from "./components/Navbar2";
import { Header83 } from "./components/Header83";
import { Header65 } from "./components/Header65";
import { Layout213 } from "./components/Layout213";
import { Layout121 } from "./components/Layout121";
import { Layout494 } from "./components/Layout494";
import { Layout159 } from "./components/Layout159";
import { Layout195 } from "./components/Layout195";
import { Layout491 } from "./components/Layout491";
import { Layout204 } from "./components/Layout204";
import { Cta31 } from "./components/Cta31";
import { Testimonial4 } from "./components/Testimonial4";
import { Faq13 } from "./components/Faq13";
import { Footer5 } from "./components/Footer5";

export default function Page() {
  return (
    <div>
      <Navbar2 />
      <Header83 />
      <Header65 />
      <Layout213 />
      <Layout121 />
      <Layout494 />
      <Layout159 />
      <Layout195 />
      <Layout491 />
      <Layout204 />
      <Cta31 />
      <Testimonial4 />
      <Faq13 />
      <Footer5 />
    </div>
  );
}
